// extracted by mini-css-extract-plugin
export var actions = "_3w-0";
export var actionsContainer = "_3w-7";
export var border = "_3w-1";
export var childFullHeight = "_3w-f";
export var collapse = "_3w-2";
export var content = "_3w-a";
export var contentChild = "_3w-e";
export var fullscreen = "_3w-c";
export var hasLeftRadius = "_3w-k";
export var headerContainer = "_3w-3";
export var headerRow = "_3w-5";
export var hidePadding = "_3w-b";
export var navCollapsedGap = "_3w-l";
export var noScrollX = "_3w-m";
export var noScrollY = "_3w-n";
export var noTopPadding = "_3w-i";
export var optOutTopPadding = "_3w-d";
export var pageMain = "_3w-j";
export var pageOuter = "_3w-g";
export var pagePadding = "_3w-8";
export var pageScroll = "_3w-9";
export var profile = "_3w-o";
export var profileContainer = "_3w-p";
export var profileImage = "_3w-q";
export var profileMain = "_3w-r";
export var profileSubtitle = "_3w-t";
export var profileTitle = "_3w-s";
export var showLeftPadding = "_3w-h";
export var tabsPortalSlot = "_3w-6";
export var tabsWrapper = "_3w-4";
export var title = "_3w-u";